<template>
  <ClientOnly>
    <span
      v-if="compact"
      class="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-black/70 text-sm font-bold text-white"
      v-bind="$attrs"
    >
      <span class="w-2 h-2 rounded-full bg-red-600" aria-hidden="true"></span>
      {{ trailerPlaysLeft }} previews left today
    </span>
    <div
      v-else
      class="bg-white/5 p-2 flex flex-col items-center"
      v-bind="$attrs"
    >
      <span class="text-xl font-bold text-red-600">
        You have {{ trailerPlaysLeft }} previews left for today.
      </span>
      <a :href="joinUrl">Join now to unlock all of our videos.</a>
    </div>
  </ClientOnly>
</template>

<script setup>
  defineOptions({
    inheritAttrs: false,
  })

  // compact: a pill over the player, for the join box layout.
  defineProps({
    compact: { type: Boolean, default: false },
  })

  const userStore = useUserStore()
  const trailerPlaysLeft = computed(() => 5 - userStore.trailerPlayCount)
  const joinUrl = "/join"
</script>
